import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../lib/auth";
import AdminSetupPage from "./AdminSetupPage";
import AdminLoginPage from "./AdminLoginPage";

// Routes to the right admin flow based on whether setup is needed.
export default function AdminEntry() {
  const { status, loading } = useAuth();

  if (loading || status === "loading")
    return (
      <div className="py-32 text-center text-inkMuted font-display" data-testid="admin-loading">
        در حال بررسی وضعیت ادمین...
      </div>
    );

  if (status === "authenticated") return <Navigate to="/admin/dashboard" replace />;
  if (status === "login") return <AdminLoginPage />;
  if (status === "setup" || status === "unconfigured") return <AdminSetupPage />;
  return <AdminLoginPage />;
}
